module.exports = __webpack_public_path__ + "img/spiris.46b3290d.png";